// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__224H0","author":"Table_author__2PtMC","authorImage":"Table_authorImage__8a2Xi","unreadRow":"Table_unreadRow__1-F7d"};